import { useCallback, useState } from 'react'

export function useToggleState(initialValue: boolean = false) {
  const [val, setVal] = useState(initialValue)

  const toggleVal = useCallback(
    (newValue?: boolean) => {
      if (newValue !== undefined) {
        setVal(newValue)
      } else {
        setVal((curr) => !curr)
      }
    },
    [setVal],
  )

  return [val, toggleVal] as const
}
